import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import JobCard from './JobCard'
import '../LandingPage/filterStyles.css'
import parse from "html-react-parser";


const CategoryFilter = ({ jobAdvertisements,
    applyHandler, onBackCareers }) => {
    const [allData, setAllData] = useState();
    const [data, setData] = useState()
    const [searchValue, setSearchValue] = useState("")

    const changeHandler = (event) => {
        const { value } = event.target;
        setSearchValue(value)
        if (value !== "") {
            setData((prev) =>
                prev.filter(
                    (item) =>
                        item.title?.toLowerCase().includes(value?.toLowerCase()) ||
                        item.advertisementNo?.toLowerCase().includes(value?.toLowerCase())
                )
            );
        } else {
            setData(allData)
        }
    };



    const clearHandler = () => {
        setData(allData)
        setSearchValue("")
    }


    const backNavigate = () => {
        // navigate("/");
        onBackCareers()
        // setFilter(false)
        // setData(copyjobAdvertisements)
    }
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant" // or "smooth"
        });
    }, []);


    useEffect(() => {
        setData(jobAdvertisements)
        setAllData(jobAdvertisements)

    }, [jobAdvertisements])

    return (
        <div className=''>
            <div className="p-3 sticky-top bg-white shadow-sm" style={{ zIndex: 100 }}>
                <button
                    onClick={backNavigate}
                    className="btn btn-lg fw-bold d-flex align-items-center gap-2 shadow-sm"
                    style={{
                        background: '#4169E1',
                        color: 'white',
                        border: 'none',
                        borderRadius: '12px',
                        padding: '12px 24px',
                        transition: 'all 0.3s ease',
                        fontSize: '1.1rem'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#5B7FE8';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 10px 20px rgba(65, 105, 225, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#4169E1';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                    }}
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M19 12H5M12 19l-7-7 7-7" />
                    </svg>
                    Back to Home
                </button>
            </div>
            <main>
                <div className="py-5 mx- container p-3">
                    <Row className="g-0 justify-content-center">
                        <div className='mb-4 px-2 d-flex'>
                            <input type='text'
                                placeholder='Search by title, job code'
                                className='form-control ms-2'
                                value={searchValue}
                                onChange={changeHandler}
                            />
                            <button className='btn border ms-2' type='button' onClick={clearHandler}>
                                Clear
                            </button>
                        </div>
                        {data?.length === 0 ? (
                            <Col className="text-center py-5 text-muted">No active positions found.</Col>
                        ) : (
                            <>
                                <div className="results-header">
                                    <h3 className='px-3'>Open Positions</h3>
                                    <div className="results-header-actions">
                                        <div className="results-meta">{data?.length} result{data?.length !== 1 ? "s" : ""}</div>
                                    </div>
                                </div>
                                {data?.map((ad) => (
                                    <JobCard key={ad.id}
                                        ad={ad}
                                        jobAdvertisements={data}
                                        width="6"
                                        applyHandler={applyHandler}
                                    />
                                ))}
                            </>
                        )}
                    </Row>
                </div>
            </main>

            <section className="general-application-section container">
                <article className="general-application-card">
                    <div className="general-application-content">
                        <h3>Interested in working with us?</h3>
                        <p className="general-application-description">
                            Don't see a position that matches your interests? We're always looking for talented individuals to join our team. Submit a general application and we'll keep your profile in mind for future opportunities.
                        </p>
                    </div>
                    <div className="general-application-actions">
                        <button
                            onClick={() => applyHandler()}
                            className="general-apply-button"
                        >
                            Apply for Future Positions
                        </button>
                    </div>
                </article>
            </section>
            <footer className=" py-5">
                <div className=" border-secondary pt-4 text-center">
                    <div className="container">© {new Date().getFullYear()} CHRIST (Deemed to be University). All rights reserved. | Equal Opportunity Employer</div>
                </div>
            </footer>
        </div>
    )
}

export default CategoryFilter